import { Injectable } from '@angular/core';
import { Effect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/nx';
import { of } from 'rxjs';
import { map ,  switchMap ,  mapTo } from 'rxjs/operators';

import { toDashedFromCamelCase } from '../../../../../helpers/';
import { GITLAB_ASSOCIATED_REPOSITORY_PL } from '../../../../constants/';
import { GetCompleteAction, HandleResponseAction, NoopAction, UndoAction } from '../../../../ngrx/actions/root.action';
import { AppState } from '../../../../ngrx/state/';
import { jsonApiToEntityState } from '../../../../shared/services/app/web-socket/http-response';
import { AtlazApiV2Service } from '../../../../shared/services/atlaz-api/v2/atlaz-api-v2.service';
import { ESGitlabAssociatedRepository } from '../../models/git-repository';
import * as gitlabAssociatedRepository from './gitlab-associated-repository.actions';

@Injectable()
export class GitlabAssociatedRepositoryEffects {
  private key = toDashedFromCamelCase(GITLAB_ASSOCIATED_REPOSITORY_PL);

  @Effect()
  getMany$ = this.data.fetch(gitlabAssociatedRepository.GET_INDEX, {
    run: (action, state) => {
      return this.api.get([this.key]).pipe(
        map(jsonApiToEntityState),
        switchMap((newState: ESGitlabAssociatedRepository) => {
          const actions = [new GetCompleteAction(newState), new gitlabAssociatedRepository.GetIndexComplete(newState)];
          return of(...actions);
        })
      );
    },
    onError: (action, error) => {
      this.defaultErrorHandler(action, error);
      return new gitlabAssociatedRepository.GetIndexFail();
    }
  });

  @Effect()
  remove$ = this.data.optimisticUpdate(gitlabAssociatedRepository.REMOVE, {
    run: (action: gitlabAssociatedRepository.Remove, store) =>
      this.api.deleteRequest([this.key, action.payload.id]).pipe(mapTo(new NoopAction())),
    undoAction: (action, err) => {
      console.error('effect', action, err);
      return new UndoAction(action);
    }
  });

  @Effect()
  create$ = this.data.pessimisticUpdate<gitlabAssociatedRepository.Create>(gitlabAssociatedRepository.CREATE, {
    run: (action, store) => this.api.post(this.key, action.payload).pipe(map(resp => new HandleResponseAction(resp))),
    onError: (action, error) => {
      console.error('effect', action, error);
    }
  });

  constructor(private data: DataPersistence<AppState>, private api: AtlazApiV2Service) {}

  defaultErrorHandler(action: any, err): void {
    console.error('gitlab-repository-effects', err, 'action', action);
  }
}
